const setMetaTag = (
  attr: "name" | "property",
  key: string,
  content: string
): (() => void) => {
  let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  const created = !el
  if (!el) {
    el = document.createElement("meta")
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  const prevContent = el.getAttribute("content")
  el.setAttribute("content", content)
  return () => {
    if (created) el.remove()
    else if (prevContent !== null) el.setAttribute("content", prevContent)
  }
}

export default setMetaTag
